import React from "react";
import { Row, Col } from "react-bootstrap";
import ProfilePictureLink from "../../../../src/images/profile-picture.webp";

var languages = ["JavaScript", "Java", "Dart"];
var technologies = [
  "Flutter",
  "Android",
  "ReactJS",
  "NodeJS",
  "Firebase",
  "MongoDB",
];

var languages = [
  {
    label: "TypeScript",
    link: "https://www.typescriptlang.org/",
  },
  {
    label: "JavaScript",
    link: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
  },
  {
    label: "Java",
    link: "https://www.java.com/en/",
  },
  // {
  //   label: "Dart",
  //   link: "https://dart.dev/",
  // },
];
var technologies = [
  {
    label: "NextJS",
    link: "https://nextjs.org/",
  },
  {
    label: "ReactJS",
    link: "https://reactjs.org/",
  },
  {
    label: "NodeJS",
    link: "https://nodejs.org/en/",
  },
  {
    label: "GraphQL",
    link: "https://graphql.org/",
  },
  // {
  //   label: "Flutter",
  //   link: "https://flutter.dev/",
  // },
  // {
  //   label: "Android",
  //   link: "https://www.android.com/",
  // },
  {
    label: "Google Cloud Platform (GCP)",
    link: "https://cloud.google.com/?hl=en",
  },
  {
    label: "Firebase",
    link: "https://firebase.google.com/",
  },
  {
    label: "Amazon Web Services (AWS)",
    link: "https://aws.amazon.com/",
  },

  {
    label: "Redis",
    link: "https://redis.io/",
  },
  {
    label: "MongoDB",
    link: "https://www.mongodb.com/",
  },
  {
    label: "Apache Kafka",
    link: "https://kafka.apache.org/",
  },
  {
    label: "Kubernetes",
    link: "https://kubernetes.io/",
  },
  {
    label: "Docker",
    link: "https://www.docker.com/",
  },
  {
    label: "Stripe",
    link: "https://stripe.com/",
  },
  {
    label: "AdobeXD",
    link: "https://www.adobe.com/africa/products/xd.html",
  },
  {
    label: "Figma",
    link: "https://www.figma.com",
  },
];

const BackStorySegment = (props) => {
  return (
    <Row className="short-backstory-segment">
      <Row>
        {" "}
        <h2 className="backstory-heading">Meet Mata</h2>
      </Row>
      <Row>
        {" "}
        <Col xl={7} lg={6} className="backstory">
          <p className="backstory-text">
            Hi, my name is Matamando Kalilani, and I am a software engineer.
            Being a creator in this digital space is an honor I take great pride
            in. There is something amazing about being able to turn ideas into a
            reality, solving problems faced by people all around the world.
            Recently, a friend of mine made me aware of the fact that not all
            amazing ideas, will come from my mind. I mean, he has a point, but I
            would suggest you look at My Projects, you know, in case he is just
            bluffing 😉.{" "}
          </p>
          <br />
          <p className="backstory-text">
            Nevertheless, I’m sure you also have earth-shattering ideas,
            probably something you believe can truly make a difference in
            society. I also know that sometimes, you might not have every tool
            needed to make those ideas happen. No worries, that’s where I come
            in, helping others design and develop that next best thing. So,
            bring me your ideas, and let’s see how I can help with making that
            dream a reality.
          </p>
        </Col>
        <Col xl={5} lg={6} className="profile-picture">
          <img
            src={ProfilePictureLink}
            style={{ maxWidth: "500px", objectFit:"contain" }}
            alt="Matamando Kalilani"
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <h3 className="backstory-subheading top-heading">Technologies</h3>
          {displayChipItems(technologies)}
          <h3 className="backstory-subheading">Languages</h3>
          {displayChipItems(languages)}
        </Col>
      </Row>
    </Row>
  );
};

function displayChipItems(array) {
  return array.map((item, index) => {
    if (index === 0) {
      return <ItemChip first={true} label={item.label} link={item.link} />;
    }
    return <ItemChip first={false} label={item.label} link={item.link} />;
  });
}

export default BackStorySegment;

function ItemChip(props) {
  var classNames = props.first ? "chip-item chip-item-first" : "chip-item";
  return (
    <div
      className={classNames}
      onClick={() => {
        if (typeof props.link !== "undefined") {
          window.open(props.link);
        }
      }}
    >
      {" "}
      <p>{props.label}</p>
    </div>
  );
}
